import React from 'react';
import { useNavigate } from 'react-router-dom';

function BasisvaardighedenListCard({ card, callback = null, showThumbnail = true, altBgColor = false }) {
    const navigate = useNavigate();

    function goToCard(card) {
        if (callback !== null) callback();
        navigate(`/vakcurriculum/basisvaardigheden/kaart/${card.slug}`);
    }

    function getCardTitle() {
        return card.subdomeinen_format.join('/') + ' – ' + card.deelvaardigheden_format.join('/') + ' (' + card.referentieniveaus_format.join('/') + ')';
    }

    function getCardSubtitle() {
        return 'Basisvaardigheden';
    }

    function getCardMeta() {
        let string = '';

        if (typeof card.klassen !== 'undefined' && card.klassen.length) {
            if (string.length) string += ' – ';
            string += 'Klas ' + card.klassen.join(', ');
        }

        if (typeof card.basisvaardigheden_format !== 'undefined' && card.basisvaardigheden_format.length) {
            if (string.length) string += ' – ';
            string += card.basisvaardigheden_format.join(', ');
        }

        return string;
    }

    return (
        <button type="button" className={'list-card list-card--basisvaardigheden' + (!showThumbnail ? ' list-card--no-thumbnail' : '') + (!!altBgColor ? ' list-card--alt' : '')} onClick={() => goToCard(card)}>
            {showThumbnail && <>
                {!!card.featured_image.thumbnail && <div className="list-card__img-wrapper" style={{ backgroundImage: `url(${card.featured_image.thumbnail})` }}></div>}
                {!card.featured_image.thumbnail && <div className="list-card__img-wrapper list-card__img-wrapper--no-image"></div>}
            </>}

            <div className="list-card__content-wrapper">
                {getCardSubtitle() && <span className="list-card__subtitle">{getCardSubtitle()}</span>}
                <span className="list-card__title heading:3">{getCardTitle()}</span>
                <span className="list-card__meta">{getCardMeta()}</span>
                <div className="list-card__excerpt default-styles"><p>{card.excerpt}</p></div>
                <div className="list-card__icon"></div>
            </div>
        </button>
    );
}

export default BasisvaardighedenListCard;